// extracted by mini-css-extract-plugin
export var errorIcon = "_l4-1";
export var nameLogo = "_l4-0";